import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

export default class extends Controller {
  visit(event) {
    if (event.target.closest("a, button")) return

    const url = this.element.dataset.url
    if (url) Turbo.visit(url)
  }
}
